'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';
import Cookies from 'js-cookie';

export default function GoogleAnalytics() {
    const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
    const [hasConsent, setHasConsent] = useState(false);

    useEffect(() => {
        const syncConsent = () => {
            const consent = Cookies.get('cookieConsent');
            setHasConsent(consent === 'accepted');
        };

        syncConsent();
        window.addEventListener('cookie-consent-updated', syncConsent);

        return () => {
            window.removeEventListener('cookie-consent-updated', syncConsent);
        };
    }, []);

    // Do not load GA until explicit consent is granted.
    if (!GA_MEASUREMENT_ID || !hasConsent) {
        return null;
    }

    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
            />
            <Script
                id="google-analytics"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());

                        // Keep GA storage disabled by default, then grant explicitly.
                        gtag('consent', 'default', {
                            'analytics_storage': 'denied'
                        });

                        gtag('consent', 'update', {
                            'analytics_storage': 'granted'
                        });
                        
                        gtag('config', '${GA_MEASUREMENT_ID}', {
                            page_path: window.location.pathname,
                            client_storage: 'none',
                            allow_google_signals: false,
                            allow_ad_personalization_signals: false,
                        });
                    `,
                }}
            />
        </>
    );
}

// Déclarer les types pour gtag
declare global {
    interface Window {
        gtag: (...args: any[]) => void;
        dataLayer: any[];
    }
}
